export default "__VITE_ASSET__iI66Mkf3__"